// extracted by mini-css-extract-plugin
export default {"copy":"Cga-z","linkButton":"Dga-z"};